import { ApiDataAdapter } from '@internal-libraries/kheops-ui-lib'
import {get} from "lodash";
import {KhListEntryConfigDTO} from "../../../Type";
import KhListEntryConfig from "../../../Type/KhListEntryConfig";

export class ConfigurationListEntryAdapter implements ApiDataAdapter<KhListEntryConfig> {
    public createClass(apiData: KhListEntryConfigDTO): KhListEntryConfig {
        return {
            id: get(apiData, 'id'),
            name: get(apiData, 'name'),
        }
    }
}
